import { render, staticRenderFns } from "./OrderChangeStatus.vue?vue&type=template&id=34f9ea68&scoped=true&"
import script from "./OrderChangeStatus.vue?vue&type=script&lang=js&"
export * from "./OrderChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f9ea68",
  null
  
)

export default component.exports